import styled from "styled-components";

export const Container = styled.div`
  background: #000;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 900px;
  position: relative;
  z-index: 1;

  @media screen and (max-width: 720px) {
    height: 1300px;
  }

`;

export const FormWrap = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media screen and (max-width: 480px) {
    margin-top: -35px;
    flex-direction: column;
  }
`;

export const FormContent = styled.div`
  display: grid;
  flex-direction: column;
  grid-template-columns: 1fr 1fr;
  gap: 100px;

  @media screen and (max-width: 720px) {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  @media screen and (max-width: 480px) {
    display: flex;
    flex-direction: column;
    grid-template-columns: 1fr 1fr;
  }
`;

export const Form = styled.div`
  background: #1C75BC; 
  height: 575px;
  width: 525px;
  display: grid;
  padding: 30px 25px;
  border-radius: 5px;
  flex-direction: column;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.9);

  @media screen and (max-width: 480px) {
    padding: 32px 32px;
    flex-direction: column;
    height: 580px;
    width: 320px;
  }
`;

export const Info = styled.div`
  margin-top: 75px;
  background: #000;
  height: 500px;
  width: 500px;
  padding: 30px 25px;
  border-radius: 5px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.9);

  @media screen and (max-width: 480px) {
    padding: 3px 3px;
    margin-top: 120px;
    flex-direction: column;
    width: 300px;
  }
`;

export const FormH1 = styled.h1`
  margin-bottom: 25px;
  color: #fff;
  font-size: 40px;
  font-weight: 500px;
  text-align: left;

  @media screen and (max-width: 480px) {
    font-size: 30px;
  }
`;

export const FormH2 = styled.h1`
  margin-bottom: 25px;
  color: #fff;
  font-size: 30px;
  font-weight: 500px;
  text-align: left;

  @media screen and (max-width: 480px) {
    font-size: 25px;
  }
`;

export const FormLabel = styled.label`
  font-size: 14px;
  color: #101522;
  flex-direction: column;

  @media screen and (max-width: 480px) {
    font-size: 12px;
    margin-bottom: 14px;
  }
`;

export const FormInput = styled.input`
  display: block;
  padding: 5px 15px;
  margin-bottom: 17px;
  margin-top: 10px;
  border: none;
  border-radius: 4px;
  width: 475px;
  height: 35px;

  @media screen and (max-width: 480px) {
    width: 255px;
    height: 40px;
    padding: 5px 1px;
    margin-bottom: 14px;
    margin-top: 10px;
    flex-direction: column;
  }
`;

export const FormMessage = styled.textarea`
display: block;
  padding: 5px 15px;
  margin-bottom: 30px;
  margin-top: 10px;
  border: none;
  border-radius: 4px;
  width: 475px;
  height: 100px;

  @media screen and (max-width: 480px) {
    width: 255px;
    height: 100px;
    padding: 5px 1px;
    margin-bottom: 20px;
    margin-top: 10px;
    flex-direction: column;
  }
`;

export const FormButton = styled.input`
  background: #101522;
  position: relative;
  top: 5%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 10px 10px;
  border-radius: 4px;
  color: #fff;
  font-size: 20px;
  cursor: pointer;

  @media screen and (max-width: 480px) {
    top: 7%;
  }
`;

export const Text = styled.p`
  margin-top: 35px;
  color: #fff;
  font-size: 20px;
  text-align: left;
  max-width: 600px;

  @media screen and (max-width: 768px) {
    font-size: 18px;
  }

  @media screen and (max-width: 480px) {
    font-size: 16px;
  }
`;

export const SocialIcons = styled.div`
  margin-top: 35px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 150px;

  @media screen and (max-width: 480px) {
    width: 200px;
  }
`;
export const SocialIconsLink = styled.a`
  color: #fff;
  font-size: 25px;

  @media screen and (max-width: 480px) {
    font-size: 35px;
  }
`;
